import { DoctorLayout } from "@/components/layout/doctor-layout";
import { CpdModulesContent } from "@/components/cpd/cpd-modules-hub";
import { BookOpenCheck } from "lucide-react";

export default function DoctorLearn() {
  return (
    <DoctorLayout title="CPD Learning Hub">
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="bg-teal-100 p-2.5 rounded-xl">
            <BookOpenCheck className="h-6 w-6 text-teal-700" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900">CPD Learning Hub</h2>
        </div>
        <p className="text-slate-600 max-w-2xl">
          Structured CPD learning modules for rheumatology clinicians — mapped to JRCPTB curriculum outcomes, NICE/BSR/EULAR guidance, and GMC Good Medical Practice standards.
        </p>
      </div>
      <CpdModulesContent moduleBasePath="/doctor/learn" />
    </DoctorLayout>
  );
}
